
import { PropType, defineComponent, ref, watch } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { isEmail, validateAll } from '../utils/validators'

const { useGetters: useContactsGetters } = createNamespacedHelpers('contacts')

export default defineComponent({
  props: {
    emails: {
      type: Array as PropType<Array<string>>,
      default: []
    }
  },
  emits: ['change', 'validationChange'],
  setup(props, { emit }) {
    const { contactEmails } = useContactsGetters(['contactEmails'])

    const valid = ref(true)
    const emailCombobox = ref<HTMLElement | null>(null)
    const localEmails = ref<Array<string>>(props.emails)

    watch(
      () => props.emails,
      emails => {
        localEmails.value = emails
      }
    )

    function handleEmailChange() {
      emit('change', localEmails.value)
    }

    function handleValidationChange() {
      emit('validationChange', valid.value)
    }

    function blurInput() {
      if (emailCombobox.value) emailCombobox.value.blur()
    }

    return {
      valid,
      blurInput,
      localEmails,
      emailCombobox,
      contactEmails,
      handleEmailChange,
      handleValidationChange,
      isEmail,
      validateAll
    }
  }
})
